export default["__VITE_ASSET__C3yzXCWi__","__VITE_ASSET__DVqtDCnm__"];